import cloneDeep from 'lodash/fp/cloneDeep'
import { listDifferenceComputer, modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import {
    PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER
    , PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS
    , PENDING_APPROVAL_STOP_EDITING_CONTACT_NUMBERS
    , PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS
    , PENDING_APPROVAL_SET_CONTACT_NUMBER
    , PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL
    , PENDING_APPROVAL_DELETE_CONTACT_NUMBER
    , PENDING_APPROVAL_DELETED_CONTACT_NUMBER
    , PENDING_APPROVAL_DELETING_CONTACT_NUMBER
    , PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER
    , PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS
    , PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
    , PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
    , PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
} from './pendingApprovaladviserProfileContactDetailsEditorActions.js'
import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'

const initialState = {
  deletingContactNumber: false,
  deleteContactNumberModal: false,
  loadingContactNumbers: false,
  editingContactNumbers: false,
  editingIndex: -1,
  deletingContactNumberIndex: -1,
  editingPublicContactEmailAddress: false,
  loadingPublicContactEmailAddress: false,
  contactNumbersBeforeEditing: [],
  contactNumbersModificationsBeforeEditing: [],
  contactDetailsModifications: {
    publicContactEmailAddress: null,
    publicContactEmailAddressModified: false,
    emailAddress: null,
    contactNumbers: []
  },
  publicContactEmailAddressBeforeEditing: null,
  isInvalid: {
    formIsValid: false,
    contactNumbers: {
      isInvalid: true,
      message: 'Please enter your contact number',
      valid: false
    },
    publicContactEmailAddress: {
      isInvalid: true,
      message: 'Please enter your email address',
      valid: false
    }
  }
}

const removeDeletedNumbers = (contactNumbers) => {
  return contactNumbers.filter((contactNumber) => contactNumber.modificationState !== modificationStates.deleted)
}

const isFormValidPublicContactEmail = (state) => {
  return state.contactDetails.isInvalid.publicContactEmailAddress.valid
}

const isFormValidContactNumbers = (state) => {
  return state.contactDetails.isInvalid.contactNumbers.valid
}

function isNumeric (n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

function validateEmail (value) {
  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter your email address',
      valid: false,
      pristine: true
    }
  }

  if (value.length < 3 || value.indexOf('@') < 0) {
    return {
      isInvalid: true,
      message: 'Email address is invalid',
      valid: false,
      pristine: false
    }
  }

  if (value.length > 320) {
    return {
      isInvalid: true,
      message: 'Email address exceeds max length (320)',
      valid: false,
      pristine: false
    }
  }

  let endingCharacter = value.slice(-1)
  if (endingCharacter === '.' || endingCharacter === '@') {
    return {
      isInvalid: true,
      message: 'Email address contains invalid characters',
      valid: false,
      pristine: false
    }
  }

  return {
    isInvalid: false,
    validationstate: 'success',
    message: null,
    valid: true,
    pristine: false
  }
}

function validatePhoneNumber (value) {
  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter your contact number',
      valid: false
    }
  }

  if (!isNumeric(value)) {
    return {
      isInvalid: true,
      message: 'Contact number must contain only digits',
      valid: false
    }
  }

  if (value.length < 10) {
    return {
      isInvalid: true,
      message: 'Contact number is not long enough',
      valid: false
    }
  }

  if (value.length > 15) {
    return {
      isInvalid: true,
      message: 'Contact number length is too long (15)',
      valid: false
    }
  }

  return {
    isInvalid: false,
    validationstate: 'success',
    message: null,
    valid: true
  }
}

export default (state = initialState, action) => {
  var newState = copyContactNumbersState(state)

  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.contactDetails.contactDetailsModifications = findContactNumbersDifferences(newState)
      return newState
    case containerEvents.edit.cancel:
      newState.contactDetails = cloneDeep(initialState)
      newState.contactDetails.contactDetailsModifications = findContactNumbersDifferences(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER:
      const updatedContactNumbers = [
        ...newState.contactDetails.contactDetailsModifications.contactNumbers,
        action.contactNumber
      ]
      newState.contactDetails = {
        ...newState.contactDetails,
        contactNumbersBeforeEditing: cloneDeep(newState.pendingApprovalProfile.contactDetails.contactNumbers),
        contactNumbersModificationsBeforeEditing: cloneDeep(newState.contactDetails.contactDetailsModifications.contactNumbers),
        contactDetailsModifications: {
          ...newState.contactDetails.contactDetailsModifications,
          contactNumbers: updatedContactNumbers
        },
        editingContactNumbers: true,
        isInvalid: {
          ...newState.contactDetails.isInvalid,
          formIsValid: false,
          contactNumbers: {
            ...newState.contactDetails.isInvalid.contactNumbers,
            valid: false
          }
        },
        editingIndex: updatedContactNumbers.length - 1
      }
      newState.pendingApprovalProfile = {
        ...newState.pendingApprovalProfile,
        contactDetails: {
          ...newState.pendingApprovalProfile.contactDetails,
          contactNumbers: removeDeletedNumbers(updatedContactNumbers)
        }
      }
      return newState
    case PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS:
      newState.contactDetails.editingContactNumbers = true
      newState.contactDetails.editingIndex = action.index
      newState.contactDetails.contactNumbersBeforeEditing = cloneDeep(newState.pendingApprovalProfile.contactDetails.contactNumbers)
      newState.contactDetails.contactNumbersModificationsBeforeEditing = cloneDeep(newState.contactDetails.contactDetailsModifications.contactNumbers)
      if (!newState.pendingApprovalProfile.contactDetails.contactNumbers || (newState.pendingApprovalProfile.contactDetails.contactNumbers.length === 0)) {
        newState.contactDetails.isInvalid.contactNumbers.valid = false
      } else {
        newState.contactDetails.isInvalid.contactNumbers = validatePhoneNumber(newState.pendingApprovalProfile.contactDetails.contactNumbers[0].contactNumber)
      }
      newState.contactDetails.isInvalid.publicContactEmailAddress = validateEmail(newState.pendingApprovalProfile.contactDetails.publicContactEmailAddress)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      return newState
    case PENDING_APPROVAL_STOP_EDITING_CONTACT_NUMBERS:
      newState.contactDetails.editingIndex = -1
      newState.contactDetails.editingContactNumbers = false
      // newState.pendingApprovalProfile.contactDetails.contactNumbers = removeDeletedNumbers(newState.contactDetails.contactDetailsModifications.contactNumbers)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS:
      newState.contactDetails.editingIndex = -1
      newState.contactDetails.editingContactNumbers = false

      if (!newState.contactDetails.contactNumbersBeforeEditing || (newState.contactDetails.contactNumbersBeforeEditing.length === 0)) {
        newState.contactDetails.isInvalid.contactNumbers.valid = false
      } else {
        newState.contactDetails.isInvalid.contactNumbers = validatePhoneNumber(newState.contactDetails.contactNumbersBeforeEditing[0].contactNumber)
      }
      newState.contactDetails.isInvalid.publicContactEmailAddress = validateEmail(newState.contactDetails.publicContactEmailAddressBeforeEditing)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)

      newState.pendingApprovalProfile.contactDetails.contactNumbers = cloneDeep(newState.contactDetails.contactNumbersBeforeEditing)
      newState.contactDetails.contactDetailsModifications.contactNumbers = cloneDeep(newState.contactDetails.contactNumbersModificationsBeforeEditing)
      newState.contactDetails.contactNumbersBeforeEditing = []
      newState.contactDetails.contactNumbersModificationsBeforeEditing = []
      return newState
    case PENDING_APPROVAL_SET_CONTACT_NUMBER:
      newState.pendingApprovalProfile.contactDetails.contactNumbers[0] = cloneDeep(action.contactNumber)
      newState.contactDetails.isInvalid.contactNumbers = action.validationResult
      // newState.pendingApprovalProfile.contactDetails.contactNumbers = removeDeletedNumbers(newState.contactDetails.contactDetailsModifications.contactNumbers)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL:
      newState.contactDetails.deleteContactNumberModal = true
      newState.contactDetails.deletingContactNumberIndex = action.index
      return newState
    case PENDING_APPROVAL_DELETE_CONTACT_NUMBER: {
      const contactDetailsModifications = newState.contactDetails.contactDetailsModifications
      contactDetailsModifications.contactNumbers = contactDetailsModifications.contactNumbers.map((contactNumber, index) => {
        if (index === newState.contactDetails.deletingContactNumberIndex) {
          contactNumber.modificationState = modificationStates.deleted
        }
        return contactNumber
      })
      newState.pendingApprovalProfile.contactDetails.contactNumbers = removeDeletedNumbers(contactDetailsModifications.contactNumbers)
      newState.edited = true
      return newState
    }
    case PENDING_APPROVAL_DELETED_CONTACT_NUMBER:
      newState.contactDetails.deletingContactNumberIndex = -1
      newState.contactDetails.deletingContactNumber = false
      newState.contactDetails.deleteContactNumberModal = false
      return newState
    case PENDING_APPROVAL_DELETING_CONTACT_NUMBER:
      newState.contactDetails.deletingContactNumber = true
      return newState
    case PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER:
      newState.contactDetails.deletingContactNumberIndex = -1
      newState.contactDetails.deleteContactNumberModal = false
      return newState
    case PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS:
      newState.pendingApprovalProfile.contactDetails.publicContactEmailAddress = action.publicContactEmailAddress
      newState.contactDetails.isInvalid.publicContactEmailAddress = action.validationResult
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      newState.contactDetails.contactDetailsModifications = findContactNumbersDifferences(newState)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS:
      newState.contactDetails.editingPublicContactEmailAddress = true
      newState.contactDetails.publicContactEmailAddressBeforeEditing = newState.pendingApprovalProfile.contactDetails.publicContactEmailAddress
      return newState
    case PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS:
      newState.contactDetails.editingPublicContactEmailAddress = false
      return newState
    case PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS:
      newState.contactDetails.editingPublicContactEmailAddress = false
      newState.pendingApprovalProfile.contactDetails.publicContactEmailAddress = newState.contactDetails.publicContactEmailAddressBeforeEditing
      return newState
  }

  return state
}

function contactDetailsFormIsValid (newState) {
  return isFormValidContactNumbers(newState) && isFormValidPublicContactEmail(newState)
}

const copyContactNumbersState = (state) => {
  return cloneDeep(state)
}

function contactNumberModified (oldItem, newItem, modifiedState, unModifiedState) {
  if (oldItem.contactNumber !== newItem.contactNumber ||
    oldItem.contactNumberType !== newItem.contactNumberType) {
    return modifiedState
  }

  return unModifiedState
}

const findContactNumbersDifferences = (state) => {
  if (state.publishedProfile) {
    const publishedProfile = state.publishedProfile
    const pendingApprovalProfile = state.pendingApprovalProfile
    var oldList = state.publishedProfile.contactDetails.contactNumbers
    var newList = state.pendingApprovalProfile.contactDetails.contactNumbers
    var modifications = {
      emailAddress: pendingApprovalProfile.contactDetails.emailAddress,
      publicContactEmailAddress: pendingApprovalProfile.contactDetails.publicContactEmailAddress,
      publicContactEmailAddressModified: publishedProfile.contactDetails.publicContactEmailAddress !== pendingApprovalProfile.contactDetails.publicContactEmailAddress,
      contactNumbers: listDifferenceComputer(oldList, newList, ['contactNumber', 'contactNumberTypeId'], contactNumberModified)
    }
  }
  return modifications
}
